"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var CallingTextContainer_1 = require("./CallingTextContainer");
var TooltipContainer_1 = require("./TooltipContainer");
var ENTER_KEY = 13;
var ESCAPE_KEYCODE = 27;
var DEFAULT_RIGHT = false;
var DEFAULT_TOP = true;
var DEFAULT_MOBILECLASS = 'tooltip-arrow-';
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.contentRef = null;
        _this.spanContentRef = null;
        _this.callingTextRef = null;
        /*
        scenario 1: true
        -----------------------------
        |   _________               |
        |  |         |              |
        |  |         |              |
        |  |_________|              |
        |    \/                     |
        | calling text              |
        |                           |
        |                           |
        -----------------------------
    
        scenario 2: false
            _________
           |         |
        -----------------------------
        |  |         |              |
        |  |_________|              |
        |    \/                     |
        | calling text              |
        |                           |
        |                           |
        |                           |
        |                           |
        -----------------------------
    
        scenario 2: false
        -----------------------------
        |                           |
        |                           |
        |                           |
        | calling text              |
        |   _/\_______              |
        |  |         |              |
        -----------------------------
           |         |
           |_________|
    
    
        */
        _this.isInVerticalView = function () {
            // istanbul ignore next
            if (_this.contentRef.current === null) {
                return false;
            }
            var boundingRect = _this.contentRef.current.getBoundingClientRect();
            return (boundingRect.top >= 0 &&
                boundingRect.bottom <= window.innerHeight);
        };
        /*
        scenario 1: true
        -----------------------------
        |   _________________       |
        |  |                 |      |
        |  |                 |      |
        |  |_________________|      |
        |    \/                     |
        | calling text              |
        |                           |
        |                           |
        -----------------------------
    
        scenario 2: false
        -----------------------------
        |                           |
        |              _________________
        |             |                 |
        |             |                 |
        |             |_________________|
        |               \/          |
        |             calling text  |
        |                           |
        |                           |
        -----------------------------
    
        */
        _this.isInHorizontalView = function () {
            // istanbul ignore next
            if (_this.contentRef.current === null) {
                return false;
            }
            var boundingRect = _this.contentRef.current.getBoundingClientRect();
            return (boundingRect.right <= window.screen.width && boundingRect.right <= window.innerWidth);
        };
        /*
    
          scenario 1: true
        -----------------------------
        |                           |
       ______________________       |
       |                     |      |
       |                     |      |
       |                     |      |
       |_____________________|      |
        |               \/          |
        |             calling text  |
        |                           |
        |                           |
        -----------------------------
    
        */
        _this.isOffPage = function () {
            // istanbul ignore next
            if (_this.contentRef.current === null) {
                return false;
            }
            var boundingRect = _this.contentRef.current.getBoundingClientRect();
            if (boundingRect.left < 0) {
                return true;
            }
            if (!_this.isInHorizontalView() && boundingRect.left < boundingRect.width) {
                return true;
            }
            return false;
        };
        // small viewports may cause the tooltip to fall of the screen if the text position does not have the required
        // left or right pixels to display. The below sets the class to manually place the box and arrow relative to the screen
        _this.forcePositionClass = function () {
            // istanbul ignore next
            if (_this.callingTextRef.current === null) {
                return DEFAULT_MOBILECLASS;
            }
            var tooltipLabelRect = _this.callingTextRef.current.getBoundingClientRect();
            var classPosition = Math.round((tooltipLabelRect.left + window.scrollX - tooltipLabelRect.width) / 10) * 10;
            return DEFAULT_MOBILECLASS + Math.abs(classPosition);
        };
        // Click handler for the close button (X)
        _this.handleCloseButtonClick = function (e) {
            // Event propagation is prevented is clicking the close button
            // will also trigger the contentFocus() method which is needed to
            // keep the tooltip open when tabbing between the tooltip label
            // and the close button
            e.preventDefault();
            _this.closeTooltip();
        };
        _this.handleCloseButtonKeyDown = function (e) {
            // Press ENTER of the close button
            if (e.keyCode === ENTER_KEY) {
                _this.closeTooltip();
            }
        };
        _this.handleKeyPress = function (e) {
            if (e.keyCode === ENTER_KEY) {
                if (_this.state.visible) {
                    // Pressing ENTER on/in an expanded tooltip will collapse it
                    _this.closeTooltip();
                }
                else {
                    // Pressing ENTER on/in a collapsed tooltip will expand it
                    _this.openTooltip();
                }
            }
            else if (e.keyCode === ESCAPE_KEYCODE) {
                // Pressing ESC in an expanded tooltip will collapse it
                _this.closeTooltip();
            }
        };
        _this.toggleVisibility = function (e) {
            if (!_this.state.visible) {
                _this.openTooltip();
            }
            else {
                _this.closeTooltip();
            }
        };
        _this.handleBlur = function () {
            // Blur executes when something else receives focus. The tooltip is closed
            // without restoring focus to the tooltip label
            _this.closeTooltip(false);
        };
        _this.contentFocus = function (e) {
            // Keep the tooltip open when the content area receives focus
            _this.openTooltip();
        };
        _this.openTooltip = function () {
            _this.setState({
                hasFocus: true,
                visible: true,
            });
        };
        _this.closeTooltip = function (restoreFocus) {
            if (restoreFocus === void 0) { restoreFocus = true; }
            // The internal states tracks whether it has focus and is visible separately. This allows
            // focus to shift from the label to the content area without it disappearing when the label
            // blurs. This is done by setting hasFocus to false, then checking in the future whether
            // it has received focus on another element. If it has not, then the visibility is turned off.
            _this.setState({
                hasFocus: false,
            }, function () { return _this.checkVisibility(restoreFocus); });
        };
        _this.checkVisibility = function (restoreFocusOnClose) {
            setTimeout(function () {
                // Has focus was turned off when this timeout was created. If it hasn't been
                // set back on when the timeout executes, the visibility is turned off.
                if (!_this.state.hasFocus) {
                    _this.setState({
                        visible: false,
                    });
                    if (restoreFocusOnClose) {
                        // Focus should be restored to the calling element when the tooltip
                        // is closed without setting focus on something new. i.e only when close button,
                        // or key press, but when user tabs to next element, opens another tooltip, or
                        // clicks on the page, etc.
                        _this.callingTextRef.current.focus();
                    }
                }
            }, 5);
        };
        _this.contentRef = React.createRef();
        _this.spanContentRef = React.createRef();
        _this.callingTextRef = React.createRef();
        _this.state = {
            displayRight: DEFAULT_RIGHT,
            displayTop: DEFAULT_TOP,
            hasFocus: false,
            mobileClass: DEFAULT_MOBILECLASS,
            visible: false,
        };
        return _this;
    }
    Tooltip.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.visible === false && this.state.visible === true) {
            // The tooltip has opened
            if (!this.isInVerticalView()) {
                this.setState({
                    displayTop: !this.state.displayTop,
                });
            }
            if (!this.isInHorizontalView()) {
                this.setState({
                    displayRight: !this.state.displayRight,
                });
            }
            // adjust arrow positioning for mobile devices
            if (this.isOffPage()) {
                this.setState({
                    mobileClass: this.forcePositionClass(),
                });
            }
        }
        else if (prevState.visible === true && this.state.visible === false) {
            // reset the default values
            this.setState({
                displayRight: DEFAULT_RIGHT,
                displayTop: DEFAULT_TOP,
            });
        }
    };
    Tooltip.prototype.render = function () {
        return (React.createElement(CallingTextContainer_1.default, { callingTextRef: this.callingTextRef, handleBlur: this.handleBlur, visible: this.state.visible, icon: this.props.icon, id: this.props.id, handleOnClick: this.toggleVisibility, handleKeyPress: this.handleKeyPress, text: this.props.text },
            React.createElement(TooltipContainer_1.default, { displayRight: this.state.displayRight, displayTop: this.state.displayTop, handleContentFocus: this.contentFocus, handleCloseButtonClick: this.handleCloseButtonClick, handleCloseButtonKeyDown: this.handleCloseButtonKeyDown, mobileClass: this.state.mobileClass, surfaceRef: this.contentRef, textRef: this.spanContentRef, text: this.props.tooltipText, visible: this.state.visible })));
    };
    return Tooltip;
}(React.Component));
exports.Tooltip = Tooltip;
// tslint:disable no-string-literal
Tooltip['propTypes'] = {
    icon: PropTypes.bool,
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    tooltipText: PropTypes.any.isRequired,
};
Tooltip['defaultProps'] = {
    icon: false,
};
// tslint:enable no-string-literal
